<div class="calendar-page" @fadeInAnimation>
  <div class="calendar-page-title">
    <span class="title">
      {{ 'CALENDAR.TITLE' | translate }}
      <span class="bold">{{ 'CALENDAR.SUBTITLE' | translate }}</span>
    </span>
    <div>
      <eps-button
        (buttonClick)="createFlorder()"
        buttonIcon="plus-square"
        label="ORDERS.FILTER.BUTTONS.ADD_ORDER"
        *ngIf="authorization.ORDER.CREATE"
        ></eps-button>
    </div>
  </div>

  <div *ngIf="authorization.ORDER.QUERY" class="calendar-page-content" [ngStyle]="{ 'height.px': height }" cdkDropListGroup>
    <!-- LEGEND AND CONTAINER -->

    <div *ngIf="isPortrait$ | async" class="device-in-portrait">
      {{ 'CALENDAR.ROTATE_TO_LANDSCAPE' | translate }}
    </div>

    <ng-container *ngIf="isLandscape$ | async">
      <div class="sticky-template-container" [ngStyle]="{ 'height.px': height - 100 }">
        <ng-container *ngIf="isReadOnly">
          <app-calendar-legend [customers]="sandbox.calendarCustomers$ | async" (customerSelected)="selectCustomer($event)"></app-calendar-legend>
        </ng-container>
        <ng-container *ngIf="!isReadOnly && canViewTemplates">
          <app-calendar-draggable-templates
            type="ORDERS"
            [authorization]="authorization"
            [templates]="(sandbox.templateState$ | async).templates"
            [editing]="(sandbox.templateState$ | async).editing"
            [deleting]="(sandbox.templateState$ | async).deleting"
            [selectedTemplate]="selectedTemplate"
            [deliveryDaysRequesting]="deliveryDaysRequesting"
            [showBack]="isSuperUser"
            (goBack)="deselectCustomer()"
            (createTemplate)="createTemplate()"
            (deleteTemplate)="deleteTemplate($event)"
            (selectTemplate)="selectTemplate($event)"
            (editTemplate)="editTemplate($event)"
            (createOrder)='createFlorderFromTemplate($event.templateId, $event.date)'
            [canViewTemplate]="sandbox.canViewTemplates$ | async"
            [isSuperUser]="isSuperUser"
            [activeCustomer]="selectedCustomer"
          >
          </app-calendar-draggable-templates>
        </ng-container>
      </div>

      <div class="template-destination">
        <div class="spacing">
          <app-calendar-filter
            [authorization]="authorization"
            [definitions]="sandbox.definitions$ | async"
            [depots]="depots$ | async"
            [filter]="filter"
            (filterCalendar)="filterCalendar($event)"
          ></app-calendar-filter>
        </div>
        <div class="calendar-container">
          <div class="calendar-wrapper">
            <app-calendar-month
              [days]="flordersState.data"
              [availableDays]="availableDays"
              [headerMessage]="(busy$ | async) === false && nothingFound ? 'CALENDAR.ORDERS.NO_ORDERS_FOUND' : ''"
              (showFlorderModal)="showFlorderModal($event)"
              (loadFlorders)="loadFlorders($event)"
              (openFlorder)="openFlorder($event)"
              (requestDeliveryDates)="requestDeliveryDates()"
            >
              <ng-template let-florderInfo let-tooltipBoundingBoxChange="tooltipBoundingBoxChange">
                <app-calendar-order-tooltip [florderInfo]="florderInfo" (boundingBoxChange)="tooltipBoundingBoxChange($event)"></app-calendar-order-tooltip>
              </ng-template>
            </app-calendar-month>
          </div>
        </div>
      </div>
    </ng-container>

  </div>
</div>
